import { IStorageTrackingAccessResponseDto } from '@/interfaces/auth/IStorageTrackingAccess.ts';
import { useApi } from '../useApi.ts';

const apiCall = useApi('storageTracking');

async function getUserAccess (): Promise<IStorageTrackingAccessResponseDto> {
    return (await apiCall.get<IStorageTrackingAccessResponseDto>({ endpoint: '/authApi/GetUserAccess' })).data;
}

export const storageTrackingAccessApi = {
    getUserAccess,
};
